import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestDashboardUserLoginDto } from "../dto/face-thermal-dashboard-users-login.dto";

@Injectable()
export class FaceThermalDashboardUserLoginApi {

  private service: string = 'thermalDashboardUserlogins';
  private model: string = 'thermalDashboardUserlogins';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  public getAdmin(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = '';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }


  public setAdmin(data: RequestDashboardUserLoginDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = '';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}





// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/face-thermal-dashboard-users-login.api.ts